import { ScreenSize, PanelMode } from "@/mds/foundations/types";

export const MDSBreakpoints = {
  [ScreenSize.Phone]: "(max-width: 520px)",
  [ScreenSize.Tablet]: "(min-width: 521px) and (max-width: 900px)",
  [ScreenSize.Desktop]: "(min-width: 901px)",
} as const;

export const MDSSidebarWidths = {
  expanded: 240,
  collapsed: 80,
} as const;

export const MDSPanelWidths = {
  min: 375,
  narrow: 480,
  headerBreakpoint: 688,
  gutter: 8,
} as const;

const PANEL_COUNT = 2;
const panelNarrowMax = MDSPanelWidths.narrow - 1;

export const MDSPanelModeBreakpoints = {
  [PanelMode.Narrow]: `(max-width: ${panelNarrowMax}px)`,
  [PanelMode.MediumSinglePanel]: `(min-width: ${MDSPanelWidths.narrow}px) and (max-width: ${MDSSidebarWidths.expanded + 1.5 * MDSPanelWidths.min + MDSPanelWidths.gutter - 1}px)`,
  [PanelMode.MediumSplitView]: `(min-width: ${MDSPanelWidths.narrow}px) and (max-width: ${MDSSidebarWidths.expanded + PANEL_COUNT * MDSPanelWidths.min + PANEL_COUNT * MDSPanelWidths.gutter - 1}px)`,
  [PanelMode.WideSinglePanel]: `(min-width: ${MDSSidebarWidths.expanded + 1.5 * MDSPanelWidths.min + MDSPanelWidths.gutter}px)`,
  [PanelMode.WideSplitView]: `(min-width: ${MDSSidebarWidths.expanded + PANEL_COUNT * MDSPanelWidths.min + PANEL_COUNT * MDSPanelWidths.gutter}px)`,
} as const;

export type IMDSBreakpoints = typeof MDSBreakpoints;
export type IMDSSidebarWidths = typeof MDSSidebarWidths;
export type IMDSPanelWidths = typeof MDSPanelWidths;
export type IMDSPanelModeBreakpoints = typeof MDSPanelModeBreakpoints;
